import app from 'flarum/common/app';
import PwaInstallPrompt from './components/PwaInstallPrompt';

app.initializers.add('alwarithun-pwa-prompt', () => {
  let pwaContainer = document.getElementById('alwarithun-pwa-prompt-root');
  if (!pwaContainer) {
    pwaContainer = document.createElement('div');
    pwaContainer.id = 'alwarithun-pwa-prompt-root';
    document.body.appendChild(pwaContainer);
  }
  m.mount(pwaContainer, { view: () => m(PwaInstallPrompt) });
});
